import { Link, useLocation } from 'react-router-dom';
import { useState, useCallback } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = useCallback(
    (path: string) => location.pathname === path,
    [location.pathname],
  );

  const linkClass = (path: string) =>
    `whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
      isActive(path)
        ? 'text-primary-600'
        : 'text-foreground-700 hover:text-primary-500'
    }`;

  return (
    <header className="relative z-50">
      <nav className="w-full">
        <div className="flex items-center justify-between px-6 md:px-12 py-4">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-heading text-2xl text-primary-500">91牛</span>
            <span className="hidden sm:inline text-xs text-foreground-500 font-medium bg-secondary-100 px-2 py-0.5 rounded-full">
              专业平台
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass('/')}>
              首页
            </Link>
            <Link to="/category/all" className={linkClass('/category/all')}>
              资源中心
            </Link>
            <Link to="/about" className={linkClass('/about')}>
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="whitespace-nowrap text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
            >
              登录
            </a>
            <a
              href="#"
              className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2 rounded-full transition-colors cursor-pointer"
            >
              免费注册
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-5 flex flex-col gap-4">
            <Link
              to="/"
              className={linkClass('/')}
              onClick={() => setMobileOpen(false)}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={linkClass('/category/all')}
              onClick={() => setMobileOpen(false)}
            >
              资源中心
            </Link>
            <Link
              to="/about"
              className={linkClass('/about')}
              onClick={() => setMobileOpen(false)}
            >
              关于我们
            </Link>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200">
              <a
                href="#"
                className="whitespace-nowrap text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              >
                登录
              </a>
              <a
                href="#"
                className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2 rounded-full transition-colors cursor-pointer"
              >
                免费注册
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}